import Rectangle from "./Rectangle";
import Area from "./Area";
import Length from "./Length";
import AbstractShape from "./AbstractShape";

export default class Star extends AbstractShape {
	static NAME = "star";
	static MINIMUM_NUMBER_OF_POINTS = 2;
	static MAXIMUM_NUMBER_OF_POINTS = 15;

	constructor( number_of_points, outer_radius, inner_radius ) {
		super();

		this.number_of_points = number_of_points;
		this.outer_radius = outer_radius;
		this.inner_radius = inner_radius;
	}

	get_name() {
		return this.constructor.NAME;
	}

	get_enclosing_rectangle() // This is a low effort rectangle, because the outer radius is also the radius of the circle that contains
	// this star, we can simply use the rectangle that fits that circle. There might be a more optimized rectangle.
	{
		let circle_radius = this.outer_radius.max( this.inner_radius );
		circle_radius = circle_radius.multiply( 2 );

		return new Rectangle( circle_radius, circle_radius );
	}

	get_area() {
		const ac        = this.outer_radius.in_mm();
		const ab        = this.inner_radius.in_mm();
		const angle_eab = 2 * Math.PI / (
			this.number_of_points * 2
		);
		const be        = ab * Math.sin( angle_eab );
		const area_abcd = be * ac;
		return new Area( this.number_of_points * area_abcd );
	}

	get_circumference() {
		const ac        = this.outer_radius.in_mm();
		const ab        = this.inner_radius.in_mm();
		const angle_eab = 2 * Math.PI / (
			this.number_of_points * 2
		);
		const be        = ab * Math.sin( angle_eab );
		const ae        = Math.sqrt( Math.pow( ab, 2 ) - Math.pow( be, 2 ) );
		const bc        = Math.sqrt( Math.pow( ac - ae, 2 ) + Math.pow( be, 2 ) );
		return new Length( this.number_of_points * 2 * bc );
	}

	get_number_of_points() {
		return this.number_of_points;
	}

	get_inner_radius() {
		return this.inner_radius;
	}

	get_outer_radius() {
		return this.outer_radius;
	}

	get_maximum_dimensions( maximum_rectangle ) //Use the same low effort method as we used in get_enclosing_rectangle.
	{
		const maximum_radius = maximum_rectangle.get_shortest_side().in_mm() / 2;
		return {
			inner_radius: new Length( maximum_radius ),
			outer_radius: new Length( maximum_radius ),
			number_of_points: this.MAXIMUM_NUMBER_OF_POINTS
		};
	}

	get_dimension_keys() {
		return [ "inner_radius", "outer_radius" ];
	}

	get_modifier_keys() {
		return [ "number_of_points" ];
	}

	serialize_primitives() {
		return {
			inner_radius: this.inner_radius.in_mm(),
			outer_radius: this.outer_radius.in_mm(),
			number_of_points: this.number_of_points
		};
	}

	static deserialize_primitives( primitives ) {
		return new Star(
			parseInt( primitives.number_of_points, 10 ),
			new Length( primitives.inner_radius ),
			new Length( primitives.outer_radius )
		);
	}

}
